export const mensajeMovilStyles = {
    'avatar': {
      width: '32px',
      height: '32px',
    },
    'box':{
      float: 'right' as 'right',
      //paddingTop: '4px',
      //paddingBottom:'4px',
      //paddingRight:'7px',
      width: '80%',
    },
    'box-empleado':{
      float: 'left' as 'left',
      width: '80%',
    }
  }